import React, { useState } from "react";
import Webmenu from "../../../layouts/webmenu";
import Topbar from "../../../layouts/topbar";
import { useDispatch } from "react-redux";
import { saveCustomerType } from "../../../actions/CustomerTypeActions";
import { useNavigate } from 'react-router-dom';
import { getAllInsuranceType, saveInsuranceType, updateInsuranceType } from "../../../actions/InsuranceTypeActions";
import Toast from "../../../components/Toast";
import { useEffect } from "react";

function AddTypeOfInsurance(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { editinsuranceType, modalType, getData, currentRowsPerPage, page } = props;

    const [name, setName] = useState('');

    const save = async () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
            }
           await dispatch(saveInsuranceType(data));
            getAllInsuranceType(page, currentRowsPerPage);
        }
        // window.location.href = ('/typeOfInsurance');
        setName("");
    }

    useEffect(() => {
        if (Object.keys(editinsuranceType).length > 0) {
            setName(editinsuranceType.name);
        }
    }, [editinsuranceType])

    const update = async () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
            }
           await dispatch(updateInsuranceType(data, editinsuranceType.insurance_type_id));
            getAllInsuranceType(page, currentRowsPerPage);
            // dispatch(getAllState());
        }
        // // window.location.href = ('/state')
        setName("")
    }
    const clearName = () => {
        setName('');
    };
    return (
        <React.Fragment>
            {/* <!-- BEGIN: Modal Content --> */}
           <div id="add-modal" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div class="modal-header">
                            <h2 class="fw-medium fs-base me-auto">{modalType == 'add' ? 'Add' : 'Edit'} Insurance Type</h2>
                        </div>
                        {/* <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="grid columns-12 gap-6">
                            <div className="intro-y g-col-12">
                                {/* <!-- BEGIN: Form Layout --> */}
                                <div className="intro-y p-5">
                                    <div>
                                        <label for="crud-form-1" className="form-label">Insurance Type Name</label>
                                        <input id="crud-form-1" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Name..." />
                                    </div>
                                    {/* <div className="mt-3">
                                    <label>Status</label>
                                    <div className="form-check form-switch mt-2">
                                        <input type="checkbox" className="form-check-input"/>
                                    </div>
                                </div> */}
                                </div>
                                {/* <!-- END: Form Layout --> */}
                            </div>
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div class="modal-footer text-end">
                            <div className="text-end">
                                <button type="button" data-bs-dismiss="modal" onClick={clearName} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                {
                                    modalType == 'add' ?
                                        <span>
                                            <button type="button" data-bs-dismiss="modal" onClick={save} className="btn btn-primary w-24 me-1">Save</button>
                                            <button type="button" onClick={save} className="btn btn-primary">Save & Add More</button>
                                        </span>
                                        :
                                        <button type="button" data-bs-dismiss="modal" onClick={update} className="btn btn-primary w-24">Update</button>
                                } 
                            </div>
                        </div>
                        {/* <!-- END: Modal Footer --> */}
                    </div>
                </div>
            </div>
            {/* <!-- END: Modal Content --> */}
        </React.Fragment>
    )
}

export default AddTypeOfInsurance;